import { render, staticRenderFns } from "./SaleHeader.vue?vue&type=template&id=65919d6a&"
import script from "./SaleHeader.vue?vue&type=script&lang=js&"
export * from "./SaleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SaleHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports